import { Table } from 'antd'
import { useState } from 'react'

import type { GpuOffer } from '../hooks/useGpuAdmin'
import { useGpuOffers } from '../hooks/useGpuAdmin'
import { useOfferExclusionChange } from '../hooks/useGpuPolicies'
import { offerColumns } from './offerColumns'
import { useOffsetPagination } from './offsetPagination'
import { ReasonModal } from './ReasonModal'

interface Props {
  provider: string
  canWrite: boolean
}

export function OffersTable({ provider, canWrite }: Props) {
  const { args, pagination } = useOffsetPagination()
  const { data, isFetching } = useGpuOffers(provider, args)
  const { exclude, allow } = useOfferExclusionChange(provider)
  const [takingOff, setTakingOff] = useState<GpuOffer>()
  const items = data?.items ?? []

  const columns = offerColumns(
    canWrite
      ? {
          onTakeOff: setTakingOff,
          onReturn: (o) => allow.mutateAsync({ key: o.provider_offer_id }),
        }
      : undefined,
    items.some((o) => o.market_evidence),
  )

  return (
    <>
      <Table<GpuOffer>
        rowKey="id"
        dataSource={items}
        columns={columns}
        loading={isFetching}
        pagination={pagination(items.length)}
        size="small"
        scroll={{ x: 'max-content' }}
        locale={{ emptyText: 'No offers in the catalog' }}
      />
      {takingOff && (
        <ReasonModal
          open
          title={`Take ${takingOff.native_offer_id ?? takingOff.id} (#${takingOff.provider_offer_id}) off sale`}
          action="Take off sale"
          target={takingOff.provider_offer_id}
          maxReason={1000}
          loading={exclude.isPending}
          onSubmit={(key, reason) => exclude.mutateAsync({ key, reason })}
          onClose={() => setTakingOff(undefined)}
        />
      )}
    </>
  )
}
